import { commonUtils } from '../common_utils';

const RAHOITUSKUMPPANI_MIN_LOAN_AMOUNT = 51;

export const rahoituskumppani = {
    removeGreenEffect() {
        $('.greenFadeEffectRahoituskumppani').removeClass('updateSec');
    },
    loadYear(defaultYears) {
        $('#rahoituskumppaniLoanPeriod').empty();

        let startYear = 1,
            endYear = 6;
        for (let year = startYear; year <= endYear; year++) {
            $('#rahoituskumppaniLoanPeriod').append(new Option(year, year));
        }

        $('#rahoituskumppaniLoanPeriod').val(defaultYears);
    },
    slider() {
        let defaultYear = $('#rahoituskumppaniLoanPeriod').val();
        let loanAmount = $('#rahoituskumppaniLoanAmount').val();

        $('.greenFadeEffectRahoituskumppani').addClass('updateSec');

        if (loanAmount < RAHOITUSKUMPPANI_MIN_LOAN_AMOUNT) {
            alert(Translations.ad_detail.finance.error.rahoituskumppani_min_loan_amount);
            loanAmount = RAHOITUSKUMPPANI_MIN_LOAN_AMOUNT;
            $('#rahoituskumppaniLoanAmount').val(loanAmount);
        }

        rahoituskumppani.loadYear(defaultYear);
        defaultYear = $('#rahoituskumppaniLoanPeriod').val();
        let sourceUrl = window.location.href.split('?')[0];
        $.ajax({
            type: 'GET',
            url: Routing.generate('finance_rahoituskumppani'),
            data: `loanAmount=${loanAmount}&loanPeriod=${defaultYear}&sourceUrl=${sourceUrl}`,
            success(data) {
                let loanData = data.rahoituskumppani;
                let installment = '-',
                    effective = '-',
                    nominal = '-',
                    loanUrl = '';
                if (loanData) {
                    installment = commonUtils.numberFormatByLocale(loanData.nominal_payment.toFixed(2));
                    effective = commonUtils.numberFormatByLocale(loanData.annual_rate.toFixed(2));
                    nominal = commonUtils.numberFormatByLocale(loanData.nominal_rate.toFixed(2));
                    loanUrl = loanData.url.length ? loanData.url : '';
                }

                $('#rahoituskumppani_monthly_payment').html(installment);
                $('#rahoituskumppani_air').html(effective);
                $('#rahoituskumppani_mir').html(nominal);
                $('#rahoituskumppaniLoan').attr('data-loan-url', loanUrl);

                setTimeout(rahoituskumppani.removeGreenEffect, 1000);
            },
        });
    },
    submit(object) {
        commonUtils.dataLayer.getLoanButtonDataLayerEvent(object.data('bank-name'));

        let loanAmount = $('#rahoituskumppaniLoanAmount').val();
        let loanMonth = $('#rahoituskumppaniLoanPeriod').val() * 12;
        let utmSource = commonUtils.getVerticalName().toLowerCase();
        let sourceUrl = globalThis.location.href.split('?')[0];
        let loanUrl = `https://ai.rahoituskumppani.fi/fi/hae-luottopaatos?utm_medium=paid-link&utm_source=${utmSource}&utm_campaign=ajoneuvolaskuri&loan_amount=${loanAmount}&payments=${loanMonth}&source_url=${sourceUrl}`;

        window.open(object.data('loan-url') ?? loanUrl, '_blank');
    },
};
